import $ from 'jquery';
import { gsap } from 'gsap';

import { $Elements, Animations, Breakpoints, Classes, Events, tcVarName } from '../global/constants';
import { elementPosition } from '../global/helpers';

// ---------- Init Scroll Animation ----------

export const initScrollAnimations = () => {

	// ---------- Parallax Section ----------

	$('.parallax-section:not(.fixed):not(.transition-clone):not(.introduction-section)').each(function() {

		Animations.global.push(() => {

			this.classList.add(Classes.moving);

			const image = this.querySelector('.section-image');
			const speed = parseInt(this.dataset.speed, 10);

			if(image) {
				const parallax = gsap.timeline({
					scrollTrigger: {
						trigger: this,
						start: 'top bottom',
						end: 'bottom top',
						scrub: true,
						invalidateOnRefresh: true,
					},
				});

				if(speed) {
					const offset = () => image.offsetHeight - ((image.offsetHeight - this.offsetHeight) / 2);

					parallax.fromTo(image,
						{ y: () => offset() * (speed / 100), ease: 'none' },
						{ y: () => offset() * (-speed / 100), ease: 'none' }
					);
				}
			}
		});
	});

	// ---------- Animated introduction-section ----------

	$('.introduction-section').each(function() {

		Animations.global.push(() => {

			this.classList.add(Classes.moving);

			const image = this.querySelector('.section-image');
			const speed = parseInt(this.dataset.speed, 10);

			if(image) {
				const parallax = gsap.timeline({
					scrollTrigger: {
						trigger: this,
						start: 'top top',
						end: 'bottom top',
						scrub: true,
						invalidateOnRefresh: true,
					},
				});

				if(speed) {
					const offset = () => image.offsetHeight - ((image.offsetHeight - this.offsetHeight) / 2);

					parallax.to(image, { y: () => offset() * (speed / 100), ease: 'none' });
				}
			}
		});
	});

	// ---------- Animated simple-text-section ----------

	$('.simple-text-section, .product-description-section').each(function() {

		Animations.global.push(() => {

			const content = this.querySelector('.content');

			if(content) {

				const timeline = gsap.timeline({
					scrollTrigger: {
						trigger: this,
						start: 'top 75%',
						end: 'bottom top',
						scrub: true,
						invalidateOnRefresh: true,
					}
				});

				const lineHeight = () => {
					const height = '300%';

					gsap.set(content, { height: 'auto' });
					gsap.set(content, { lineHeight: height });
					gsap.set(content, { height: content.offsetHeight });

					return height;
				}

				timeline.fromTo(
					content,
					{ lineHeight: () => lineHeight(), ease: 'none' },
					{ lineHeight: () => '150%', ease: 'none' }
				);

				timeline.to(content, { [tcVarName('after-opacity')]: 1, ease: 'none', duration: .3 }, 0);
				timeline.to(content, { [tcVarName('after-width')]: '70px', ease: 'none' }, 0.1);
			}
		});
	});

	// ---------- Animated subtitle-section ---------

	$('.subtitle-section').each(function() {

		Animations.global.push(() => {

			const content = this.querySelector('.content');

			if(content) {

				const timeline = gsap.timeline({
					scrollTrigger: {
						trigger: this,
						start: 'top 75%',
						end: 'bottom top',
						scrub: true,
						invalidateOnRefresh: true,
					}
				});

				timeline.to(content, { [tcVarName('after-height')]: '20vh', ease: 'none' });
			}
		});
	});

	// ---------- Animated three-images-text-section ----------

	$('.three-images-text-section').each(function() {

		Animations.mobile.min.push(() => {

			const imageCenter = this.querySelector('.image-center');
			const imageLeft = this.querySelector('.image-left');
			const imageRight = this.querySelector('.image-right');
			const paragraph = this.querySelector('.paragraph-column');

			const timeline = gsap.timeline({
				scrollTrigger: {
					trigger: this,
					start: 'top bottom',
					end: 'bottom top',
					scrub: true,
					invalidateOnRefresh: true,
				},
			});

			if(imageCenter) {
				timeline.to(imageCenter, { y: '5vh', opacity: .5, ease: 'none' }, 0);
			}
			const offset = () => (paragraph) ? (paragraph.offsetHeight + (window.innerHeight * .1)) : '50%';

			if(imageLeft) {
				timeline.fromTo(
					imageLeft,
					{ y: 0, ease: 'none' },
					{ y: () => offset(), ease: 'none' },
					0
				);
			}

			if(imageRight) {
				timeline.fromTo(
					imageRight,
					{ y: () => offset(), ease: 'none' },
					{ y: 0, ease: 'none' },
					0
				);
			}
		});
	});

	// ---------- Animated simple-text-image-section ----------

	$('.simple-text-image-section, .two-images-text-section, .superimposed-images-text-section, .team-section, .list-tour-section, .history-section, .posts-section').each(function() {

		Animations.mobile.min.push(() => {

			const image = this.querySelector('.image-column');

			if(image) {

				const timeline = gsap.timeline({
					scrollTrigger: {
						trigger: this,
						start: 'top bottom',
						end: 'bottom top',
						scrub: true,
						invalidateOnRefresh: true,
					},
				});

				timeline.fromTo(
					image,
					{ y: '10vh', ease: 'none' },
					{ y: '-10vh', ease: 'none' }
				);

				const secondImage = image.querySelector('.image:nth-child(2)');

				if(secondImage) {
					timeline.to(secondImage, { y: '-33%', ease: 'none' }, 0);
				}

				const opacity = gsap.timeline({
					scrollTrigger: {
						trigger: this,
						start: 'top bottom',
						end: 'top top',
						scrub: true,
						invalidateOnRefresh: true,
					},
				});

				opacity.fromTo(
					image,
					{ opacity: 0, ease: 'none' },
					{ opacity: 1, ease: 'none' }
				);
			}
		});
	});

	// ---------- Animated text-background-section ----------

	$('.text-background-section').each(function() {

		Animations.global.push(() => {

			const content = this.querySelector('.highlighted');

			if(content) {

				const timeline = gsap.timeline({
					scrollTrigger: {
						trigger: content,
						start: 'top bottom',
						end: 'top top',
						scrub: true,
						invalidateOnRefresh: true,
					}
				});

				timeline.to(content, { [tcVarName('after-opacity')]: 1, ease: 'none', duration: .3 }, 0);
				timeline.to(content, { [tcVarName('after-height')]: '70px', ease: 'none' }, 0.1);
			}
		});
	});

	// ---------- Animated gallery-section ---------

	$('.gallery-section, .product-gallery-section').each(function() {

		Animations.global.push(() => {

			const content = this.querySelector(':scope .content');

			if(content) {

				const columns = gsap.utils.toArray('.column', content);
				const contentWidth = () => columns.reduce((val, column) => val + column.offsetWidth, 0);
				const triggerOffset = () => {
					const position = elementPosition(content);
					return position.top;
				}

				const timeline = gsap.timeline({
					scrollTrigger: {
						trigger: this,
						pin: true,
						scrub: true,
						invalidateOnRefresh: true,
						start: () => (contentWidth() > (window.innerWidth + 1)) ? triggerOffset() : 'top top',
						end: () => (contentWidth() > (window.innerWidth + 1)) ? '+=' + contentWidth() : 'bottom bottom',
					},
				});

				timeline.to(content, { x: () => window.innerWidth - contentWidth(), ease: "none" });
			}
		});
	});

	// ---------- Animated text-images-slider-section ---------

	$('.text-images-slider-section, .link-images-slider-section').each(function() {

		Animations.global.push(() => {

			const content = this.querySelector(':scope .section-columns');

			if(content) {

				const columns = gsap.utils.toArray('.content-column', content);
				const contentWidth = () => (columns.reduce((val, column) => val + column.offsetWidth, 0)) + Math.max(0, window.innerWidth - Breakpoints.xxl);
				const triggerOffset = () => {
					const position = elementPosition(content);
					return position.top;
				}

				const timeline = gsap.timeline({
					scrollTrigger: {
						trigger: this,
						pin: true,
						scrub: true,
						invalidateOnRefresh: true,
						start: () => triggerOffset(),
						end: () => '+=' + contentWidth(),
					},
				});

				timeline.to(content, { x: () => window.innerWidth - contentWidth(), ease: "none" });
			}
		});
	});

	// ---------- Animated hero-product-section ---------

	$('.hero-product-section').each(function() {

		Animations.global.push(() => {

			const image = this.querySelector(':scope .background');
			const speed = 50;

			if(image) {

				const parallax = gsap.timeline({
					scrollTrigger: {
						trigger: this,
						start: 'top top',
						end: 'bottom top',
						scrub: true,
						invalidateOnRefresh: true,
					},
				});

				if(speed) {
					const offset = () => image.offsetHeight - ((image.offsetHeight - this.offsetHeight) / 2);

					parallax.to(image, { y: () => offset() * (-speed / 100), ease: 'none' });
				}
			}
		});
	});

	// ---------- Animated text-background-section ----------

	$('.wines-slider-section').each(function() {

		Animations.global.push(() => {

			const content = this.querySelector('.background');

			if(content) {

				const timeline = gsap.timeline({
					scrollTrigger: {
						trigger: this,
						start: 'top bottom',
						end: 'bottom top',
						scrub: true,
						invalidateOnRefresh: true,
					}
				});

				timeline.to(content, { y: '30vh', ease: 'none' });
			}
		});
	});

	// ---------- Animated Section ----------

	$('.animated-section:not(.transition-clone)').each(function() {

		Animations.global.push(() => {

			const timeline = gsap.timeline({
				scrollTrigger: {
					trigger: this,
					once: true,
					start: 'top 80%',
					toggleClass: Classes.active,
				}
			});
		});
	});

	// ---------- Animated header-wrapper ---------

	$Elements.HeaderWrapper.each(function() {

		Animations.global.push(() => {

			gsap.timeline({
				scrollTrigger: {
					start: 1,
					end: 'max',
					onUpdate: (self) => {
						(self.direction === -1) ? this.classList.remove(Classes.shrink) : this.classList.add(Classes.shrink);
						(self.progress > 0) ? this.classList.add(Classes.shrinkable) : this.classList.remove(Classes.shrinkable);
					}
				}
			});
		});
	});

}

$Elements.document.on(Events.page.enter, () => initScrollAnimations());
